import { Button as ChakraButton, chakra } from '@chakra-ui/react'

const Button = chakra(ChakraButton)

export default Button
